import { EmailAddressZ } from "../helpers/isValidEmail/isValidEmail.js";

type FormatEmailResult =
  | { error: true; errorMessage: string; data: null }
  | { error: false; errorMessage: null; data: string };

export const formatEmail = (input: string): FormatEmailResult => {
  if (!input || typeof input !== "string") {
    return {
      error: true,
      errorMessage: "Invalid input: email must be a non-empty string",
      data: null,
    };
  }

  const result = EmailAddressZ.safeParse(input);

  if (!result.success) {
    return {
      error: true,
      errorMessage: `Invalid email format: "${input}"`,
      data: null,
    };
  }

  return {
    error: false,
    errorMessage: null,
    data: result.data,
  };
};
